define([
    'jquery',
    'mage/translate',
    'matchSize',
    'slick',
    'mainGtm',
], ($, $t, matchSize, slick, gtm) => {
    return function(config, element) {
        return {
            slider: undefined,
            options: {
                title: '',
                gtmCategory: '',
                gtmLinkUrl: '',
            },

            init(config, element) {
                this.slider = $(element);

                this.options.title = $t(config.title);
                this.options.gtmLinkUrl = config.gtmLinkUrl ? config.gtmLinkUrl : '';
                this.options.gtmCategory = config.gtmCategory ? config.gtmCategory : 'homepage';

                this.initSlider(this.slider);
                this.initGtmEvents(this.slider);
            },

            initSlider($slider) {
                $slider.find('.product-item').each((i, el) => {
                    $(el).css('display', 'block');
                });

                $slider.slick({
                    arrows: !matchSize().mobile,
                    dots: false,
                    variableWidth: true,
                    infinite: true,
                    centerMode: !matchSize().desktop,
                    slidesToShow: (matchSize().desktop === true ) ? 3 : 2,
                });
            },

            initGtmEvents($slider) {
                this.createGtmArrowClick($slider, '.slick-prev', 'previous');
                this.createGtmArrowClick($slider, '.slick-next', 'next');
            },

            createGtmArrowClick($slider, arrow, type) {
                $slider.find(arrow).on('click', (el) => {
                    const $target = $(el.currentTarget),
                        $slider = $target.parents('.slick-slider'),
                        slidesToShow = $slider.slick('getOption', 'slidesToShow'),
                        slidesToScroll = $slider.slick('getOption', 'slidesToScroll'),
                        currentSliderId = $slider.slick('getCurrent'),
                        slideId = $target.hasClass('slick-next')
                            ? currentSliderId + slidesToShow - slidesToScroll
                            : currentSliderId,
                        $slide = $slider.find(`[data-slick-index="${slideId}"]`),
                        type = $target.hasClass('slick-next') ? 'next' : 'previous',
                        url = $slide.find('a').attr('href');

                    gtm.clickSliderArrow(this.options.gtmCategory, this.options.title, type, url);
                }).bind(this);
            },
        }.init(config, element);
    };
});
